import { Currency, ETHER, Token, ChainId, Native } from '@abstra-dex/sdk'
import { VelasIcon } from 'packages/uikit'
import { useMemo } from 'react'
import styled from 'styled-components'
import { WrappedTokenInfo } from 'state/types'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { BitcoinIcon } from 'components/abstradex/components/svgs'
import useHttpLocations from '../../hooks/useHttpLocations'
import getTokenLogoURL from '../../utils/getTokenLogoURL'
import Logo from './Logo'

const StyledLogo = styled(Logo)<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: 50%;
  border: 1px solid #000;
`

export default function CurrencyLogo({
  currency,
  size = '24px',
  style,
  helpColor,
  chain,
}: {
  currency?: Currency
  size?: string
  style?: React.CSSProperties
  helpColor?: string
  chain: ChainId
}) {
  const uriLocations = useHttpLocations(currency instanceof WrappedTokenInfo ? currency.logoURI : undefined)
  const { chainId } = useActiveWeb3React()

  const mainnetURL = useMemo(() => {
    return ChainId.MAINNET ? 'mainnet/' : ''
  }, [])

  const srcs: string[] = useMemo(() => {
    if (currency === ETHER) return []

    if (chain) {
      if (chain !== chainId) {
        if (currency instanceof Token) {
          if (currency instanceof WrappedTokenInfo) {
            return [...uriLocations, getTokenLogoURL(`${mainnetURL}${currency.address}`)]
          }
          return [getTokenLogoURL(`${mainnetURL}${currency.address}`)]
        }
      }

      if (chain !== chainId) {
        const token = Native.onChain(chain)
        return [...uriLocations, getTokenLogoURL(`${mainnetURL}${token.wrapped.address}`)]
      }

      if (chain === chainId) {
        if (currency instanceof Token) {
          if (currency instanceof WrappedTokenInfo) {
            return [...uriLocations, getTokenLogoURL(`${mainnetURL}${currency.address}`)]
          }
          return [getTokenLogoURL(`${mainnetURL}${currency.address}`)]
        }
      }

      if (chain === chainId) {
        const token = Native.onChain(chain)
        return [...uriLocations, getTokenLogoURL(`${mainnetURL}${token.wrapped.address}`)]
      }
    }

    if (currency instanceof Token) {
      if (currency instanceof WrappedTokenInfo) {
        return [...uriLocations, getTokenLogoURL(`${mainnetURL}${currency.address}`)]
      }
      return [getTokenLogoURL(`${mainnetURL}${currency.address}`)]
    }
    return []
  }, [currency, chain, chainId, mainnetURL, uriLocations])

  if (chain === ChainId.BTC_MAINNET || chain === ChainId.BTC_TESTNET) {
    return <BitcoinIcon width={size} style={style} />
  }

  if (currency === ETHER || currency === Native.onChain(ChainId.MAINNET)) {
    return <VelasIcon width={size} style={style} />
  }

  return (
    <StyledLogo
      helpColor={helpColor}
      size={size}
      srcs={srcs}
      alt={`${currency?.symbol ?? 'token'} logo`}
      style={style}
    />
  )
}
